module.exports = __webpack_public_path__ + "img/saddle-invited.f505dbcd.svg";